import { useContext, useEffect, useState } from "react";
import { getCountries, getDepartments, getCities } from "../services/configurations/pointsOfAttention/params";
import { AppContext } from "../context";

export const usePointsParams = () => {
  const {
    t,
    toast,
    appState: { selectedApp },
  } = useContext(AppContext);
  const [listCountries, setListCountries] = useState<any>([]);
  const [listDepartments, setListDepartments] = useState([]);
  const [listCities, setListCities] = useState([]);
  const [reload, setReload] = useState<number>(0);

  const reloadFn = () => {
    setListCountries([]);
    setListDepartments([]);
    setListCities([]);
    setReload((prev) => prev + 1);
  };

  useEffect(() => {
    (async function () {
    await Promise.resolve(getCountries(selectedApp?.tenantid!))
        .then((response) => {
        const countriesResponse = response?.data;
        setListCountries(countriesResponse.map((country:any)=>({
          label: country.name,
          value: country.id,
        })));
        })
        .catch((error) => {
        toast.current.replace({
            severity: "error",
            summary: "",
            detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
            life: 3000,
        });
        });
    })();

    (async function () {
      await Promise.resolve(getDepartments(selectedApp?.tenantid!))
          .then((response) => {
          const departmentsResponse = response?.data;
          setListDepartments(departmentsResponse.map((department:any)=>({
            label: department.name,
            value: department.id,
            countryId: department.country.id,
          })));
          })
          .catch((error) => {
          toast.current.replace({
              severity: "error",
              summary: "",
              detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
              life: 3000,
          });
          });
      })();

    (async function () {
      await Promise.resolve(getCities(selectedApp?.tenantid!))
          .then((response) => {
          const citiesResponse = response?.data;
          setListCities(citiesResponse.map((city:any)=>({
            label: city.name,
            value: city.id,
            stateId: city.state.id,
            countryId: city.country.id,
          })));
          })
          .catch((error) => {
          toast.current.replace({
              severity: "error",
              summary: "",
              detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
              life: 3000,
          });
          });
      })();

  }, [toast, reload]);

  return {
    listCountries,
    listDepartments,
    listCities,
    reloadFn,
  };
};